// extracted by mini-css-extract-plugin
export default {"premium-folder-icon":"_3D1J4","premiumFolderIcon":"_3D1J4"};